/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_SavedInputs */

const en_company_profile_saved = /** @type {(inputs: Company_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company profile saved successfully.`)
};

const de_company_profile_saved = /** @type {(inputs: Company_Profile_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensprofil erfolgreich gespeichert.`)
};

/**
* | output |
* | --- |
* | "Company profile saved successfully." |
*
* @param {Company_Profile_SavedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_saved = /** @type {((inputs?: Company_Profile_SavedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_SavedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_saved(inputs)
	return en_company_profile_saved(inputs)
});